import { css } from '@emotion/css';

export const dialogSizeStyles = css`
  width: 52rem;
  max-height: 62rem;
  min-height: 62rem;
`;
